export const REACT_APP_SITE_NAME =
  process.env.REACT_APP_SITE_NAME || "HealthAdmin";
export const REACT_APP_JWT_KEY =
  process.env.REACT_APP_JWT_KEY || "pellar-theia-web-token";
export const REACT_APP_API_ROOT_URL =
  process.env.REACT_APP_API_ROOT_URL || "https://health-federation.pellar.io";
export const REACT_APP_PAGESIZE = process.env.REACT_APP_PAGESIZE || "50";
export const REACT_APP_ORG_NAME =
  process.env.REACT_APP_ORG_NAME || "SAE Access Inc";
export const REACT_APP_MODE = "ISOLATION";
export const ASSET_SOURCE = "webapp";
export const REACT_APP_MULTI_LANG =
  process.env.REACT_APP_MULTI_LANG === "true" || true;
